import { useEffect, useState } from "react";
import { IFOrder } from "views/utils/CommonConst";
import { getTimeRange, string8ToFormatDateString } from "views/utils/CommonFunc";
import { IFUseOrder } from "views/utils/UseOrder";

interface IFProps {
    index: number,
    clickShowCalendar: any,
    order: IFUseOrder,
}

export function ReservationSelectDateTimeControl(props:IFProps): JSX.Element{

    const [selectDate, setSelectDate] = useState("");
    const [selectStartTime, setSelectStartTime] = useState("");
    const [selectEndTime, setSelectEndTime] = useState("");

    useEffect(function(){
        switch (props.index){
            case 0:
                setSelectDate(props.order.data.reserve_date_1);
                setSelectStartTime(props.order.data.reserve_start_time_1);
                setSelectEndTime(props.order.data.reserve_end_time_1);
                break;
            case 1:
                setSelectDate(props.order.data.reserve_date_2);
                setSelectStartTime(props.order.data.reserve_start_time_2);
                setSelectEndTime(props.order.data.reserve_end_time_2);
                break;
            case 2:
                setSelectDate(props.order.data.reserve_date_3);
                setSelectStartTime(props.order.data.reserve_start_time_3);
                setSelectEndTime(props.order.data.reserve_end_time_3);
                break;
        }
    }, [props.order]);

    //カレンダーを表示する
    function clickShowCalendar(){
        props.clickShowCalendar(props.index);
    }

    //選択日付を解除する
    function clickDelSelectDateTime(){
        let tmpOrder:IFOrder = {...props.order.data};
        switch(props.index){
            case 0:
                tmpOrder.reserve_date_1 = "";
                tmpOrder.reserve_start_time_1 = "";
                tmpOrder.reserve_end_time_1 = "";
                break;
            case 1:
                tmpOrder.reserve_date_2 = "";
                tmpOrder.reserve_start_time_2 = "";;
                tmpOrder.reserve_end_time_2 = "";;
                break;
            case 2:
                tmpOrder.reserve_date_3 = "";;
                tmpOrder.reserve_start_time_3 = "";;
                tmpOrder.reserve_end_time_3 = "";;
                break;
        }        
        props.order.setData(tmpOrder);
    }

    if (selectDate){
        return (
            <div className="order-select-date-datetime">
                <div>
                    <p className="date">{string8ToFormatDateString(selectDate)}</p>
                    <p className="time">{getTimeRange(selectStartTime, selectEndTime)}</p>
                </div>
                <div className="control-horizon order-select-date-datetime-btns">
                    <button className="btn-tertiary" onClick={clickShowCalendar}>変更</button>
                    <button className="btn-tertiary" onClick={clickDelSelectDateTime}>削除</button>
                </div>
            </div>
        )
    } else {
        return (
            <div className="order-select-date-datetime">
                <button className="btn-secondary" onClick={clickShowCalendar}>希望日時を選ぶ</button>
            </div>
        )
    }

}